
export * from './common/app.common.module';
export * from './primeng/primeng.module';
